import { ErrorBoundary } from 'components/ErrorBoundary';
import FrequentlyBuyTogether from 'components/FrequentlyBuyTogether';
import { ContainerState, ICheckout } from 'containers/CheckoutPage/types';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Cart, CartItem, ProductNoteInput } from 'types/schema';
import CheckoutOrderTable from './CheckoutOrderTable';

const Wrapper = styled.div`
  width: 100% !important;
`;

export const Description = styled.div`
  white-space: normal;
`;

interface ICheckoutStep1 {
  notAvailableProducts: CartItem[];
  checkout: ICheckout;
  cart: Cart & { loading: boolean };
  onRemoveCartItem: (data: CartItem) => void;
  onRemoveAllNotAvailableProducts: (data: { items: CartItem[] }) => void;
  setProductNote: (data: ProductNoteInput) => void;
  noteItemLoading: boolean;
  voucherState: ContainerState['vouchers'];
}

const CheckoutStep1: FC<ICheckoutStep1> = (props) => {
  const {
    checkout,
    cart,
    onRemoveCartItem,
    onRemoveAllNotAvailableProducts,
    notAvailableProducts,
    setProductNote,
    noteItemLoading,
    voucherState: { itemDiscount },
  } = props;

  return (
    <Wrapper>
      {cart?.cartSet?.map((singleSupplierCart, index) => {
        return (
          <ErrorBoundary key={`step-1-${index}`}>
            <CheckoutOrderTable
              key={`singleSupplierCartStep1-${index}`}
              name={`step-1-${index}`}
              singleSupplierCart={singleSupplierCart}
              productsQuantity={checkout.quantity}
              onRemoveItem={onRemoveCartItem}
              onRemoveAllNotAvailableItems={(items) => onRemoveAllNotAvailableProducts({ items: items })}
              setProductNote={setProductNote}
              noteItemLoading={noteItemLoading}
              itemDiscount={itemDiscount}
              currentStep={1}
              notAvailableProducts={notAvailableProducts}
            />
          </ErrorBoundary>
        );
      })}
      <FrequentlyBuyTogether />
    </Wrapper>
  );
};

export default CheckoutStep1;
